<template>
  <!--
      作者：kmdshop
      时间：2019-10-25
      描述：客户详情
  -->
  <div class="pb50" v-loading="loading">
    <!--内容-->
    <div class="product-content">
      <!--基本信息-->
      <div class="common-form">基本信息</div>
      <div class="table-wrap">
        <el-row>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">订单号：</span>
             <span v-if="detail.order && detail.order.order_no"> {{ detail.order.order_no }}</span>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">用户ID：</span>
              {{ detail.rvisit_id }}
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16" >
              <div style="float: left;" class="gray9">头像：</div>
              <div>  <el-image v-if="detail.user && detail.user.avatarUrl" style="width: 50px;height: 50px;float: left;" :src="detail.user.avatarUrl"></el-image></div>
              <div style="clear: both;"></div>
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">昵称：</span>
             <span v-if="detail.user && detail.user.nickName">{{ detail.user.nickName }}</span>     
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">手机号：</span>
                <span v-if="detail.user && detail.user.mobile">{{ detail.user.mobile }}</span>     
            </div>
          </el-col>
   
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">性别：</span>
              <span v-if="detail.user && detail.user.gender"> {{ detail.user.gender==0?"女":"男" }}</span>     
            </div>
          </el-col>
          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">注册时间：</span>

              <span v-if="detail.user && detail.user.create_time">{{ detail.user.create_time }}</span>     
            </div>
          </el-col>

          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">回访状态：</span>

              <span v-if="detail.status == 0">回访进行中 </span>  
              <span v-if="detail.status == 1">已完结 </span>    
            </div>
          </el-col>

          <el-col :span="5">
            <div class="pb16">
              <span class="gray9">最终编辑人员：</span>

              <span v-if="detail.opshopuser &&  detail.opshopuser.user_name">{{ detail.opshopuser.user_name }}
                <span v-if=" detail.opshopuser.real_name">({{ detail.opshopuser.real_name }})</span>
                </span>   
            </div>
          </el-col>


    
        </el-row>
      </div>

  
      
      
   

          <!-- 回访主题记录 -->
          <template >
            <div class="common-form mt16">回访主题记录</div>

            <div>
             <el-button v-if="detail.status == 0" icon="el-icon-plus" type="primary" @click.stop="addRemark">增加回访主题记录</el-button>
             <el-button icon="el-icon" @click.stop="flush">刷新</el-button>
           </div>

           <div class="table-wrap" style="margin-top: 15px;">
            <el-table size="small" :data="rvisitRemarkData" border style="width: 80%">
              <el-table-column prop="product_name" label="序号" >
                <template slot-scope="scope">
                  <div class="product-info">
                    {{ scope.$index +1 }}
                  </div>
                </template>
              </el-table-column>



              <el-table-column prop="content" label="备注内容" width="200"></el-table-column>

              <el-table-column prop="name" label="照片" width="200">
                <template  slot-scope="scope">
                  <div style="height: 80px;width:210px; overflow-x:auto;">
                    <div v-for="(item,index) in scope.row.images" :key="index" style="float: left;">
                      <el-image style="width: 50px; height: 50px;" :src="item.file_path" fit="fit"
                      ref="preview" :preview-src-list="scope.row.images_arr"
                      ></el-image>
                    </div>
                    <div style="clear: both;"></div>
                  </div>
                  
                  
                </template>

            </el-table-column>

             <el-table-column  label="最终编辑人员">
              <template slot-scope="scope">
                <div v-if="scope.row.opshopuser &&  scope.row.opshopuser.user_name">{{ scope.row.opshopuser.user_name }}
                <span v-if=" scope.row.opshopuser.real_name">({{ scope.row.opshopuser.real_name }})</span>
                </div>
              </template>

            </el-table-column>
            <el-table-column prop="create_time" label="备注时间" width="150"></el-table-column>
            <el-table-column prop="update_time" label="修改时间" width="150"></el-table-column>
              <el-table-column prop="product_weight" label="操作" v-if="detail.status == 0">
                <template slot-scope="scope" >
                  <div class="d-b-c">
                    <el-button  @click="editRemark(scope.row.rvisit_remark_id)" type="text" size="small" >编辑</el-button>
                    <el-button  @click="delRemark(scope.row.rvisit_remark_id)" type="text" size="small" >删除</el-button>
                  </div>
               </template>
              </el-table-column>
       
            </el-table>
          </div>
        </template>

 


  

 </div>

  

  

    <div class="common-button-wrapper" >
      <el-button size="small" type="info" @click="cancelFunc" v-if="!this.rvisit_id">返回上一页</el-button>
      <el-button v-if="detail.status == 0" size="small" type="primary" @click="finish" :loading="loading">完成回访</el-button>
    

    </div>

    <RemarkAdd :open_add="is_remark_add" v-if="is_remark_add" :rvisit_id="detail.rvisit_id" @close="closeServiceFunc"></RemarkAdd>
    <RemarkEdit :open_edit="is_remark_edit" v-if="is_remark_edit" :rvisit_remark_id="rvisit_remark_id" @close="closeServiceFunc"></RemarkEdit>
   </div>
</template>

<script>
  import RvisitApi from '@/api/rvisit.js';
  import clip from '@/utils/clipboard'

  import RemarkAdd from './remark/add.vue'
  import RemarkEdit from './remark/edit.vue'
  import {
    deepClone
  } from '@/utils/base.js';
  export default {
    components: {
      RemarkAdd,
      RemarkEdit,
    },
    data() {
      return {
        active: 0,
        /*是否加载完成*/
        loading: true,
        /*订单数据*/
        detail: {
          pay_status: [],
          pay_type: [],
          delivery_type: [],
          user: {},
          address: [],
          product: [],
          order_status: [],
          extract: [],
          extract_store: [],
          express: [],
          delivery_status: [],
          extractClerk: [],
          delivery_warehouse: ''
        },
        /*是否打开添加弹窗*/
        open_add: false,
        /*一页多少条*/
        pageSize: 20,
        /*一共多少条数据*/
        totalDataNumber: 0,
        /*当前是第几页*/
        curPage: 1,
        /*发货*/
        form: {
          /*订单ID*/
          express_id: null,
          /*订单号*/
          express_no: ''
        },
        forms: {
          is_cancel: 1
        },
        extract_form: {
          order: {
            extract_status: 1
          }
        },
        order: {},
        delivery_type: 0,
        /*配送方式*/
        exStyle: [],
        /*门店列表*/
        shopList: [],
        /*当前编辑的对象*/
        userModel: {},
        /*时间*/
        create_time: '',
        /*快递公司列表*/
        expressList: [],
        shopClerkList: [],
        /*是否打开编辑弹窗*/
        open_edit: false,
        supply_id:0,
        // 选择用户flag
        isOpenGetUser: false,
        // 选择的配送员列表,只有一个
        select_list: [],
        deliveryForm: {

        },
        rvisitRemarkData:[],
        totalDataNumber:0,
        is_service:false,
        searchForm:{

        },
        is_remark_add:false,
        is_remark_edit:false,
        rvisit_remark_id:0,


        status:0,
   

      };
    },
    props: ['rvisit_id'],
    created() {

      /*获取列表*/
      this.getData();
    },
    methods: {
        handleCopy(text, event) {
        clip(text, event)
      },
      serviceClick(e){
        this.order_id = e.order_id;
        this.is_service = true;
      },
      /*选择第几页*/
      handleCurrentChange(val) {
        let self = this;
        self.curPage = val;
        self.getData();
      },

      /*每页多少条*/
      handleSizeChange(val) {
        this.curPage = 1;
        this.pageSize = val;
        this.getData();
      },

       /*切换菜单*/
      handleClick(tab, event) {
        let self = this;
        self.curPage = 1;
        self.getData();
      },
    /*跨多列*/
    arraySpanMethod(row) {
      if (row.rowIndex % 2 == 0) {
        if (row.columnIndex === 0) {
          return [1, 8];
        }
      }
    },
     addRemark(){//新增备注
      
        this.is_remark_add = true;
      },
      editRemark(rvisit_remark_id){//修改备注
        this.rvisit_remark_id = rvisit_remark_id;
        this.is_remark_edit = true;
       
      },
      finish(){
        var self = this;
        let rvisit_id = self.detail.rvisit_id;
    
        self
          .$confirm('是否完结该回访', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            RvisitApi.finish_rvisit(
              {
                rvisit_id: rvisit_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '完结成功',
                    type: 'success'
                  });
                  this.getData();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      delRemark(rvisit_remark_id){//删除备注
        let self = this;
        self
          .$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          })
          .then(() => {
            RvisitApi.del_remark(
              {
                rvisit_remark_id: rvisit_remark_id
              },
              true
            )
              .then(data => {
                if (data.code == 1) {
                  self.$message({
                    message: '删除成功',
                    type: 'success'
                  });
                  this.getData();
                } else {
                  self.$message.error('错了哦，这是一条错误消息');
                }
              })
              .catch(error => {
              });
          })
          .catch(() => {
          });
      },
      flush(){
        this.getData();
      },

      next() {
        if (this.active++ > 4) this.active = 0;
      },
          /*搜索查询*/
    onSubmit() {
      this.curPage = 1;
      this.tableData = [];
      this.getData();
    },
      /*获取参数*/
      getData() {
        let self = this;
        // 取到路由带过来的参数
        var Params = this.searchForm;
        Params.page = self.curPage;
        Params.rvisit_id =  this.rvisit_id ? this.rvisit_id : this.$route.query.rvisit_id
        Params.list_rows = self.pageSize;
        Params.XDEBUG_SESSION_START = 'PHPSTORM'
        RvisitApi.getDetail(Params ).then(data => {
          self.loading = false;
          self.detail = data.data.detail;
          self.rvisitRemarkData = data.data.rvisitRemark.data
          self.totalDataNumber = data.data.rvisitRemark.total;
        })
          .catch(error => {
            self.loading = false;
          });
      },


      /*打开编辑*/
      editClick(item) {
        this.userModel = deepClone(item);
        this.open_edit = true;
      },

      /*关闭弹窗*/
      closeDialogFunc(e, f) {
        if (f == 'edit') {
          this.open_edit = e.openDialog;
          this.getData();
        }
      },

      /*取消*/
      cancelFunc() {
        this.$router.back(-1);
      },
      /*打开获取用户*/
      openGetUser() {
        this.isOpenGetUser = true
      },
      /*关闭获取用户*/
      closeGetUserFunc(e) {
        if (e.type != 'error') {
          this.select_list = [e.params]
        }
        this.isOpenGetUser = false
      },
      closeServiceFunc(e){
        this.getData();
        this.is_remark_add = false
        this.is_remark_edit = false
      },
  

    }
  };
</script>
<style></style>



// WEBPACK FOOTER //
// src/views/plus/rvisit/rvisit/part/detail.vue